import React from 'react'
import { getPresentationContentStyles, Grid, Typography, makeStyles, QuoteIcon } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import type { LabelsOption } from '@paintscout/util/builder'

const useStyles = makeStyles<Theme, QuotePlaceholderProps>((theme) => ({
  root: {
    '&$root': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 125,
      backgroundColor: theme.palette.grey[100],
      ...getPresentationContentStyles(theme, { noMargins: ['li'] })
    }
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    textAlign: 'center'
  }
}))

export interface QuotePlaceholderProps {
  classes?: StyleClasses<typeof useStyles>
  objectLabels: LabelsOption
}

function QuotePlaceholder(props: QuotePlaceholderProps) {
  const classes = useStyles(props)
  const { objectLabels } = props

  return (
    <div className={classes.root}>
      <Grid className={classes.container} container spacing={1}>
        <Grid item xs={8}>
          <QuoteIcon />
        </Grid>
        <Grid item xs={8}>
          <Typography variant={'h2'}>{`Custom ${objectLabels.quote.value}`}</Typography>
        </Grid>
        <Grid className={classes.container} item xs={8}>
          <Typography variant={'subtitle1'}>{`${objectLabels.quote.plural} are inserted automatically.`}</Typography>
          <Typography variant={'subtitle1'}>
            {`When viewing or sending, your ${objectLabels.quote.value.toLowerCase()} will be inserted wherever this placeholder is set in the presentation.`}
          </Typography>
        </Grid>
        <Grid className={classes.container} item xs={6}></Grid>
      </Grid>
    </div>
  )
}

export default QuotePlaceholder
